// extracted by mini-css-extract-plugin
module.exports = {"coupon_card":"Coupon2_coupon_card__mx4b2","eco-img":"Coupon2_eco-img__rYrPk","eco-img-item":"Coupon2_eco-img-item__3fRkW"};